import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-input-icon',
  templateUrl: 'rmt-input-icon.html'
})
export class RmtInputIconComponent {
  @Input() name;
  @Input() control;
  @Input() clickable: boolean = false;
  @Input() disable: boolean = false;
  @Input() iconType :string;
  @Input() iconCssClass = '';
  @Input() onClickIcon;

  constructor() {
  }

  ngOnInit(){ // using var not function on html make the function call happen one time not repeating  
    this.iconCssClass = !this.iconCssClass ? this.getIonIconCssClass() : this.iconCssClass;
  }

  clickIcon() {
    if (this.control && this.control.value)
      this.control.value = '';
    if(this.onClickIcon) 
      this.onClickIcon();
  }

  getIonIconCssClass() {
    if (this.iconType=="error") {
        return 'icon-error';
    } 
    else  if (this.iconType=="warning") {
      return 'icon-warning';
    }
    else  if (this.iconType=="warning") {
      return 'icon-warning';
    }else {
       return 'icon-default';
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/rmt-input-icon/rmt-input-icon.ts